import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import Coin from 'components/Coin'
import GameCardScores from '../GameCardScores'
import { ordinalizeSuffix } from 'lib/ordinalize'

interface Props {
  rank: number
  score: number
  firstPrize: number
}

const styles = createStyles({
  value: {
    fontSize: 16,
    fontWeight: 500,
  },
  rankSuffix: {
    top: -4,
    left: 1,
    opacity: .5,
    fontSize: 10,
    position: 'relative',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardScoresLive: React.SFC<InjectedProps> = ({
  classes,
  rank,
  score,
  firstPrize,
}) => {
  // TODO: translation keys needed

  return (
    <GameCardScores
      columns={[{
        value: (
          <Typography className={classes.value}>
            <span>{rank}</span>
            <span className={classes.rankSuffix}>{ordinalizeSuffix(rank)}</span>
          </Typography>
        ),
        label: 'ranking',
      }, {
        value: (
          <Typography className={classes.value}>
            {score}
          </Typography>
        ),
        label: 'points',
      }, {
        value: (
          <Coin className={classes.value} value={firstPrize} />
        ),
        label: 'first prize',
      }]}
    />
  )
}

export default withStyles(styles)(GameCardScoresLive)
